export default __webpack_public_path__ + "static/media/PngItem_3850359.b3cedf8e.png";